import { render } from "./ObjectCode.vue?vue&type=template&id=86e5a5bc&scoped=true"
import script from "./ObjectCode.vue?vue&type=script&lang=js"
export * from "./ObjectCode.vue?vue&type=script&lang=js"

import "./ObjectCode.vue?vue&type=style&index=0&id=86e5a5bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86e5a5bc"]])

export default __exports__